import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import debounce from 'debounce-promise'
import {FormattedMessage, useIntl} from "react-intl";
import messages from "./messages";

const Medias = ({ state: { medias }, setState }) => {
  const { formatMessage } = useIntl()
  const [mediasOptions, setMediasOptions] = useState([])

  useEffect(() => {
      fetch('/rest/v2/ordertargetmedia?search[hidden]=0&search[deleted]=0&page=0&pageSize=50&orderField=name&orderDirection=1')
        .then(response => response.json())
        .then((medias) => {
          setMediasOptions(medias.map(({ uid, name }) => ({ value: uid, label: name }))) 
        })
        .catch((err) => {
          window.alert(`${formatMessage(messages.error)}: ${err}`);
        })
  }, []);
 
  return (
    <div className="my-4">
      <div className="text-gray-500 mb-2">Medias</div>
      <Select
        className="my-2"
        value={medias}
        onChange={(medias) => setState((state) => ({ ...state, medias }))}
        isMulti
        options={mediasOptions}
        openMenuOnFocus
        noOptionsMessage={({ inputValue }) => `${formatMessage(messages.noOptions)} '${inputValue}'`}
        loadingMessage={({ inputValue }) => `${formatMessage(messages.searching)} '${inputValue}'..`}
        placeholder={formatMessage(messages.medias)}
      />
    </div>
  )
}

export default Medias
